<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, navigateTo } from '#app'

const props = withDefaults(defineProps<{
  collapsed?: boolean
  householdName?: string
}>(), {
  collapsed: false,
  householdName: 'Select Household'
})

const route = useRoute()
const householdPath = '/household/overview'

const isHouseholdSelected = computed(() => route.path.startsWith('/household'))

const baseClass = computed(() =>
  props.collapsed
    ? 'size-10 shrink-0 p-0 mt-3 flex items-center justify-center rounded text-sm font-extrabold hover:transition-transform duration-200'
    : 'w-full text-xs font-extrabold mt-3 rounded p-3 tracking-widest uppercase hover:transition-transform duration-300'
)

const stateClass = computed(() =>
  isHouseholdSelected.value
    ? 'bg-green-500 text-white'
    : 'bg-[#DDEEE3] text-black hover:text-white hover:bg-green-500'
)

const label = computed(() =>
  props.collapsed
    // Collapsed rail = a 40px square, so show just the household's initial
    // (the full name overflowed the tiny box before).
    ? (props.householdName?.trim()?.charAt(0)?.toUpperCase() || '?')
    : (props.householdName || 'Select Household')
)

const onSelectHousehold = async () => {
  // await navigateTo(householdPath)
}
</script>

<template>
  <UButton
    :to="householdPath"
    :class="`${baseClass} ${stateClass}`"
    :label="label"
    @click="onSelectHousehold"
  />
</template>
